import { addDays, isBefore } from '@if/core/date'
import { EPaymentFrequency } from '@if/core/types'
import { normalizeDateTime } from '@if/core/utils'

export const getMinMaxPaymentDates = (deliveryDateStr: string, paymentFrequency: EPaymentFrequency): [Date, Date] => {
  const parsedDate = normalizeDateTime(deliveryDateStr)
  const minDate = addDays(parsedDate, 2)
  let maxDate: Date
  switch (paymentFrequency) {
    // 2 day buffer between delivery and first payment
    // Up to 1 month from the delivery for monthly payments
    // Up to 2 weeks from the delivery for every two weeks payments
    case EPaymentFrequency.Monthly:
      maxDate = addDays(parsedDate, 30)
      break
    case EPaymentFrequency.BiWeekly:
      maxDate = addDays(parsedDate, 14)
      break
    default:
      maxDate = addDays(parsedDate, 5)
      break
  }

  return [minDate, maxDate]
}

export const isValidFirstPayment = (deliveryDateStr: string, firstPaymentOn: string) => {
  const minValidPaymentDate = addDays(normalizeDateTime(deliveryDateStr), 2)
  const normalizedFirstPaymentDate = normalizeDateTime(firstPaymentOn)
  return !isBefore(normalizedFirstPaymentDate, minValidPaymentDate)
}
